module.exports = __webpack_public_path__ + "img/album13_05.37c5bf3d.jpg";